<template>
    <div class="messages" ref="messagesContainer" tabindex="0">
        <div v-if="messages.length === 0" class="no-messages-block">
            No messages in this room yet.<br />
            Be the first one which adds one!
        </div>
        <a-message
            v-for="(message, index) in messages"
            :key="`msg-${index}`"
            :message-blob="message"
            :password="password"
        />
    </div>
</template>

<script>
import { ref } from 'vue';

import AMessage from './a-message.vue';

import { autoScrollDown } from '../composables/auto-scroll-down.js';

export default {
    props: {
        messages: {
            type: Array,
            required: true,
        },
        password: {
            type: String,
            required: true,
        }
    },
    components: {
        AMessage,
    },
    setup(props) {
        const messagesContainer = ref(null);
        autoScrollDown(() => props.messages, messagesContainer);
        return {
            messagesContainer,
        };
    },
};
</script>

<style scoped>
.messages {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.no-messages-block {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>